// src/components/common/Forms.js
import styled from 'styled-components';

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
  width: 100%;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(0, 82, 204, 0.2);
  }
`;

export const Message = styled.div`
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 8px;
  text-align: center;
  font-weight: bold;
  color: ${props => (props.type === 'error' ? '#D8000C' : '#4F8A10')};
  background-color: ${props => (props.type === 'error' ? '#FFD2D2' : '#DFF2BF')};
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 15px;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  background-color: white;
  -webkit-appearance: none; /* Remove a aparência padrão no Safari/Chrome */
  -moz-appearance: none;    /* Remove a aparência padrão no Firefox */
  appearance: none;         /* Remove a aparência padrão */
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22/%3E%3C/svg%3E');
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 0.65em auto;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(0, 82, 204, 0.2);
  }
`;

export const PhoneInputContainer = styled.div`
  display: flex;
  gap: 10px;

  select {
    flex: 0 1 150px; // A largura do select de país
  }

  input {
    flex: 1 1 auto; // O input do número ocupa o resto
  }
`;